import React from 'react';
import classNames from 'classnames';
import './ButtonRow.less';

interface IButtonRowProps extends Omit<React.HTMLProps<HTMLTableRowElement>, 'onClick' | 'children'> {
  text: string;
  colSpan: number;
  buttonClassName?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const getClassName = (className?: string) => classNames('tt-table__button-row', className);
const getButtonClassName = (className?: string) => classNames('tt-table__button-row-btn', className);

/**
 * Table row with a button inside. Supposed to used in the bottom part of table.
 * For example, "Add Row" button for truth table or "Load More" button for external truth table.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ButtonRow({ text, colSpan, onClick, className, buttonClassName }: IButtonRowProps) {
  return (
    <tr className={getClassName(className)}>
      <td colSpan={colSpan}>
        <button className={getButtonClassName(buttonClassName)} onClick={onClick}>
          {text}
        </button>
      </td>
    </tr>
  );
}
